const PIXEL_ID = '1161146862102483'

export const analytics = {
  // Re-init the pixel with Manual Advanced Matching data once the user is known.
  // Raw values are passed as-is; the pixel SHA-256 hashes them automatically.
  // Only non-empty fields are sent (phoneNumber is optional in our DB).
  identify(user) {
    if (typeof window === 'undefined' || !window.fbq || !user) return

    const matching = {}
    if (user.email) matching.em = String(user.email).trim().toLowerCase()
    if (user.phoneNumber) matching.ph = String(user.phoneNumber).replace(/\D/g, '')
    if (user.name) {
      const parts = String(user.name).trim().split(/\s+/)
      if (parts[0]) matching.fn = parts[0].toLowerCase()
      if (parts.length > 1) matching.ln = parts[parts.length - 1].toLowerCase()
    }

    if (!Object.keys(matching).length) return
    window.fbq('init', PIXEL_ID, matching)
  },

  pageView() {
    if (typeof window === 'undefined' || !window.fbq) return
    window.fbq('track', 'PageView')
  },

  search(searchTerm) {
    if (typeof window === 'undefined' || !window.fbq) return

    window.fbq('track', 'Search', {
      search_string: searchTerm
    })
  },

  addToCart(product, price, quantity = 1) {
    if (typeof window === 'undefined' || !window.fbq) return

    window.fbq('track', 'AddToCart', {
      content_ids: [product._id],
      content_name: product.title,
      content_type: 'product',
      value: price,
      currency: 'BDT',
      num_items: quantity,
    })
  },

  addToWishlist(product, price, quantity = 1) {
    if (typeof window === 'undefined' || !window.fbq) return

    window.fbq('track', 'AddToWishlist', {
      content_ids: [product._id],
      content_name: product.title,
      content_type: 'product',
      value: price,
      currency: 'BDT',
      num_items: quantity,
    })
  },

  viewContent(product, price) {
    if (typeof window === 'undefined' || !window.fbq) return

    window.fbq('track', 'ViewContent', {
      content_ids: [product._id],
      content_name: product.title,
      content_type: 'product',
      value: price,
      currency: 'BDT',
    })
  },

  initiateCheckout(cartItems, cartTotal) {
    if (typeof window === 'undefined' || !window.fbq) return

    window.fbq('track', 'InitiateCheckout', {
      content_ids: cartItems.map(item => item._id),
      content_type: 'product',
      num_items: cartItems.length,
      value: Number(cartTotal),
      currency: 'BDT'
    })
  },

  purchase(orderedItems, subTotal, eventId) {
    if (typeof window === 'undefined' || !window.fbq) return

    window.fbq('track', 'Purchase',
      {
        content_ids: orderedItems.map(p => p._id),
        content_type: 'product',
        value:  Number(subTotal),
        currency: 'BDT',
      },
      {
        eventID: eventId
      })
  },
}